module.exports = __webpack_public_path__ + "12_2x.jpg?634bef78e35bb065f6c617982d9d9709";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/12_2x.jpg
// module id = 19
// module chunks = 0